import React, { useEffect, useState, useRef } from 'react'

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
}

const ExpandableValue = ({ value }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const textRef = useRef(null);

  const textString = String(value || "");

  useEffect(() => {
    const handleResize = () => {
      const element = textRef.current;
      if (element) {
        setHasOverflow(element.scrollHeight > element.clientHeight);
      }
    };

    // Delay checking slightly to ensure layouts/styles are applied
    const timer = setTimeout(handleResize, 100);

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [textString, isExpanded]);

  return (
    <span className="ml-4 flex flex-col items-start">
      <span
        ref={textRef}
        className={`font-semibold text-gray-700 ${!isExpanded ? "line-clamp-2" : ""}`}
      >
        {textString}
      </span>
      {(hasOverflow || isExpanded) && (
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-[#9F2225] text-[10px] font-bold mt-1 hover:underline cursor-pointer focus:outline-none"
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </span>
  );
};

const Product_Description = (product_details_list) => {
  const isMobile = useIsMobile();
  const product_description_data = product_details_list?.data?.product
  const rawCustomValues = product_description_data?.custom_title;

  // Parse only if it's a string
  let CustomValues = [];

  try {
    CustomValues = typeof rawCustomValues === 'string'
      ? JSON.parse(rawCustomValues)
      : Array.isArray(rawCustomValues)
        ? rawCustomValues
        : [];
  } catch (error) {
    console.error("Error parsing custom_title:", error);
    CustomValues = [];
  }


  const detailsList = [];
  if (product_description_data?.certificate) {
    detailsList.push({
      label: "Certification",
      value: product_description_data?.certificate?.name
    });
  }
  if (product_description_data?.treatment?.name) {
    detailsList.push({
      label: "Treatment",
      value: product_description_data?.treatment?.name
    });
  }

  if (product_description_data?.shape?.name) {
    detailsList.push({
      label: "Shape",
      value: product_description_data?.shape?.name
    });
  }
  if (product_description_data?.origin?.name) {
    detailsList.push({
      label: "Origin",
      value: product_description_data?.origin?.name
    });
  }
  if (product_description_data?.color?.name) {
    detailsList.push({
      label: "Color",
      value: product_description_data?.color?.name
    });
  }
  if (product_description_data?.cut?.name) {
    detailsList.push({
      label: "Cut",
      value: product_description_data?.cut?.name
    });
  }
  if (product_description_data?.composition?.name) {
    detailsList.push({
      label: "Composition",
      value: product_description_data?.composition?.name
    });
  }
  if (product_description_data?.material) {
    detailsList.push({
      label: "Material",
      value: product_description_data?.material
    });
  }

  if (product_description_data?.gross_weight) {
    detailsList.push({
      label: "Gross Weight",
      value: product_description_data?.gross_weight
    });
  }
  if (product_description_data?.brand) {
    detailsList.push({
      label: "Brand",
      value: product_description_data?.brand
    });
  }
  if (product_description_data?.dimension) {
    detailsList.push({
      label: "Dimension",
      value: product_description_data?.dimension
    });
  }
  if (product_description_data?.gemstone) {
    detailsList.push({
      label: "Gemstone",
      value: product_description_data?.gemstone
    });
  }

  if (product_description_data?.design) {
    detailsList.push({
      label: "Design",
      value: product_description_data?.design
    });
  }
  if (product_description_data?.weight_type && product_description_data?.weight_type ==
    "ratti") {
    detailsList.push({
      label: "Ratti",
      value: product_description_data?.weight1,
    },
      {
        label: "Carat",
        value: product_description_data?.weight2,
      }
    );

  }
  if (product_description_data?.weight_type && product_description_data?.weight_type ==
    "carat") {
    detailsList.push({
      label: "Ratti",
      value: product_description_data?.weight2
    },
      {
        label: "Carat",
        value: product_description_data?.weight1
      }
    );
  }
  if (CustomValues?.length > 0) {
    CustomValues.forEach((custom) => {
      detailsList.push({
        label: custom?.title,
        value: custom?.value
      });
    });
  }

  const chunkSize = isMobile ? 1 : 3;
  const chunkedDetails = [];
  for (let i = 0; i < detailsList.length; i += chunkSize) {
    chunkedDetails.push(detailsList.slice(i, i + chunkSize));
  }

  return (
    <div id="gi-spt-nav-details" className="tab-single-pane ">
      <div className="gi-single-pro-tab-desc">
        {/* <h2 className="text-2xl font-bold">Product Details</h2> */}
        {/* <p
                    className="mb-[15px] text-[14px] tracking-[0] text-[#777] leading-[28px] font-normal">
                    Natural Emerald weighing 5.81 carat In Octagonal shape.</p> */}
        <table className='w-full'>
          <div className="detailsinfo">
            {chunkedDetails.map((rowItems, rowIndex) => (
              <div
                key={rowIndex}
                className={`grid md:grid-cols-3 grid-cols-1 ${rowIndex % 2 === 0 ? "bg-white" : "bg-[#eee]"
                  }`}
              >
                {rowItems.map((item, ind) => (
                  <li
                    key={ind}
                    className="list-disc text-[12px] font-normal text-black flex !px-3 py-2"
                  >
                    <h4 className="min-w-[120px] font-bold capitalize">{item.label}</h4>:
                    <ExpandableValue value={item.value} />
                  </li>
                ))}
              </div>
            ))}
          </div>

        </table>
      </div>
      {/*  */}
    </div>
  )
}

export default Product_Description